<div class="confirmation-wrapper">
  <div class="confirmation-container">
    <!-- Icon -->
    <div class="icon-circle">
      <i class="bi" [ngClass]="mode === 'set-password' ? 'bi-key-fill' : 'bi-hand-thumbs-up-fill'"></i>
    </div>

    <!-- ================= MODE: set-password ================= -->
    <ng-container *ngIf="mode === 'set-password'">
      <h1 class="heading">One more step to go</h1>
      <p class="subheading">Set your password to access your profile.</p>

      <div class="card password-card">
        <!-- Loading -->
        <ng-container *ngIf="passwordLinkLoading">
          <app-skeleton-loader type="line" [height]="44"></app-skeleton-loader>
          <p class="link-note mt-3 mb-0">Preparing your link…</p>
        </ng-container>

        <!-- Link ready: the parent is auto-redirected to this URL; the button/link below is
             a manual fallback in case the automatic redirect is blocked. -->
        <ng-container *ngIf="!passwordLinkLoading && passwordLink">
          <p class="link-note mb-2">Redirecting you to set your password…</p>
          <a matRipple class="btn btn-primary w-100 main-height" [href]="passwordLink" rel="noopener">
            <i class="bi bi-key me-2"></i>Continue to set my password
          </a>
          <div class="link-row">
            <span class="link-text" [title]="passwordLink">{{ passwordLink }}</span>
            <button type="button" class="link-copy-btn" (click)="copyPasswordLink()" aria-label="Copy password setup link">
              <i class="bi bi-copy"></i>
            </button>
          </div>
          <p class="link-note mb-0">We've also emailed this link to you.</p>
        </ng-container>

        <!-- Error / no link -->
        <div *ngIf="!passwordLinkLoading && (passwordLinkError || !passwordLink)" class="link-alert" role="status">
          <i class="bi bi-info-circle-fill"></i>
          <span>We couldn't load your link right now. Check your email — we've sent the same link there.</span>
        </div>
      </div>
    </ng-container>

    <!-- ================= MODE: review (default) ================= -->
    <ng-container *ngIf="mode === 'review'">
    <!-- Heading -->
    <h1 class="heading" *ngIf="name" style="text-transform: capitalize;">Thanks {{ name }}!</h1>
    <h1 class="heading" *ngIf="!name">Thanks!</h1>

    <!-- Subheading -->
    <p class="subheading">Your registration is under review</p>

    <!-- Review Progress Card -->
    <div class="card review-card">
      <div class="card-header">
        <span class="card-title">Review progress</span>
        <span class="review-badge">Under review</span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
      <div class="progress-details">
        <div class="progress-row">
          <i class="bi bi-people"></i>
          <span>#1 in line</span>
        </div>
        <div class="progress-row">
          <i class="bi bi-clock"></i>
          <span>Typically completed in &lt;6 hours</span>
        </div>
      </div>
      <!-- TODO(backend): replace "#1 in line" and "<6 hours" with real queue position and ETA from backend once available -->
    </div>

    <!-- Skip the line Card -->
    <div class="card skip-card" style="display:none;">
      <div class="skip-header">
        <i class="bi bi-phone"></i>
        <h3>Skip the line!</h3>
      </div>
      <p class="skip-subtitle">App users get 2x faster approvals!</p>

      <div class="qr-placeholder">
        <i class="bi bi-qr-code"></i>
      </div>

      <div class="app-buttons">
        <a href="#" class="app-btn app-store">
          <i class="bi bi-Apple"></i> App Store
        </a>
        <a href="#" class="app-btn google-play">
          <i class="bi bi-google"></i> Google Play
        </a>
      </div>
      <!-- TODO: add real App Store and Google Play links -->
    </div>

    <!-- Pro tip banner -->
    <div class="pro-tip-banner" style="display:none;">
      <p>Pro tip: Players who practice headers score 3x more goals from corners!</p>
    </div>
    </ng-container>
  </div>
</div>
